export const LISTING_ID_LABEL = 'Listing ID';

export const LISTING_ID_PLACEHOLDER = 'e.g. LP-12345';

export const LISTING_ID_HELPER =
  'Use the same reference your brokerage listing site uses — not the street address.';

export const LISTING_SYNC_COMING_SOON_COPY =
  'Auto sync is coming soon. It will turn on once your listing site sends status for this listing ID. Enter status and dates below for now.';
